<template>
  <div>
    <table-card
      :items="exchanges"
      :fields="fields"
      title="Exchange Partners">

      <template v-slot:cell(settings)="data">
        <div class="hidden-button-group float-right">
          <icon-button :to="{ name: 'AdminExchangeSettings', params: { cid: data.item.company_id }}" icon="icon-Settings"
                       variant="outline-border" tooltip="Settings"></icon-button>
        </div>
      </template>
    </table-card>
  </div>
</template>

<script>
    import {ExchangeApi} from '@/exchange/api'
    import TableCard from '@/components/TableCard'

    export default {
        name: 'AdminExchangeList',
        created() {
          ExchangeApi.list().then((list) => this.exchanges = list)
        },
        data() {
            return {
                exchanges: [],
                fields: [
                    {key: 'company_id'},
                    {key: 'name'},
                    {key: 'enabled'},
                    {key: 'settings', label: ''}
                ]
            }
        },
        components: {
            TableCard
        }
    }
</script>



// WEBPACK FOOTER //
// src/admin/pages/ExchangeList.vue